import { ReactNode } from 'react';
import Header from './Header';
import UserDebugPanel from './UserDebugPanel';
import { useTranslation } from '../i18n/useTranslation';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md">
        {t('App.Common.SkipToMainContent')}
      </a>
      <Header />
      <main id="main-content" tabIndex={-1} className="container-app py-8 flex-1">
        {children}
      </main>
      <UserDebugPanel />
    </div>
  );
}
